import { API_HOST, getHttpGetOptions, getHttpPostOptions, getHttpPutOptions } from '../../utils/api-util';

const getEndpoint = () => `${API_HOST}/product`;

const getViewAllClassificationsEndpoint = () => `${getEndpoint()}/view/classifications`;
export const getViewAllClassificationsRequest = () => [getViewAllClassificationsEndpoint(), getHttpGetOptions()];

const getViewAllCategoriesEndpoint = (classificationExternalReference) =>
  `${getEndpoint()}/view/categories/${classificationExternalReference}`;
export const getViewAllCategoriesRequest = (classificationExternalReference) => [
  getViewAllCategoriesEndpoint(classificationExternalReference),
  getHttpGetOptions(),
];

const getViewAllTypesEndpoint = (categoryExternalReference) =>
  `${getEndpoint()}/view/types/${categoryExternalReference}`;
export const getViewAllTypesRequest = (categoryExternalReference) => [
  getViewAllTypesEndpoint(categoryExternalReference),
  getHttpGetOptions(),
];

const getViewMetricUnitsEndpoint = (typeExternalReference) =>
  `${getEndpoint()}/view/metric-units/${typeExternalReference}`;
export const getViewMetricUnitsRequest = (typeExternalReference) => [
  getViewMetricUnitsEndpoint(typeExternalReference),
  getHttpGetOptions(),
];

const getViewAllMetricUnitsEndpoint = () => `${getEndpoint()}/retrieve/metric-units`;
export const getViewAllMetricUnitsRequest = () => [getViewAllMetricUnitsEndpoint(), getHttpGetOptions()];

const getCreateProductListingEndpoint = () => `${getEndpoint()}/create/product/listing`;
export const getCreateProductListingRequest = (productListing) => [
  getCreateProductListingEndpoint(),
  getHttpPostOptions(productListing),
];

const getViewPersonProductListingsEndpoint = () => `${getEndpoint()}/view/product/listing`;
export const getViewPersonProductListingsRequest = (filters) => [
  getViewPersonProductListingsEndpoint(),
  getHttpPostOptions(filters),
];

const getViewAllTypesRegistrationEndpoint = () => `${API_HOST}/registration/view/all/types`;

export const getViewAllTypesRegistrationRequest = () => [getViewAllTypesRegistrationEndpoint(), getHttpGetOptions()];

const getViewMarketProductListingsEndpoint = () => `${getEndpoint()}/market/view/product/listings`;
export const getViewMarketProductListingsRequest = (filters) => [
  getViewMarketProductListingsEndpoint(),
  getHttpPostOptions(filters),
];

const getViewMarketBuyerListingsEndpoint = () => `${getEndpoint()}/market/view/buyer/listings`;
export const getViewMarketBuyerListingsRequest = (filters) => [
  getViewMarketBuyerListingsEndpoint(),
  getHttpPostOptions(filters),
];

const getViewProductListingEndpoint = (productExternalReference) =>
  `${getEndpoint()}/retrieve/product/listing/${productExternalReference}`;
export const getViewProductListingRequest = (productExternalReference) => [
  getViewProductListingEndpoint(productExternalReference),
  getHttpGetOptions(),
];

const getUpdateProductListingEndpoint = () => `${getEndpoint()}/update/product/listing`;
export const getUpdateProductListingRequest = (productListing) => [
  getUpdateProductListingEndpoint(),
  getHttpPutOptions(productListing),
];

const getCreateBuyerListingEndpoint = () => `${getEndpoint()}/create/buyer/listing`;
export const getCreateBuyerListingRequest = (buyerListing) => [
  getCreateBuyerListingEndpoint(),
  getHttpPostOptions(buyerListing),
];

const getBookmarkProductListingEndpoint = (productExternalReference, type) =>
  `${getEndpoint()}/bookmark/${productExternalReference}/${type}`;
export const getBookmarkProductListingRequest = (productExternalReference, type) => [
  getBookmarkProductListingEndpoint(productExternalReference, type),
  getHttpPostOptions(),
];

const getViewPersonBuyerListingsEndpoint = () => `${getEndpoint()}/view/buyer/listing`;
export const getViewPersonBuyerListingsRequest = (filters) => [
  getViewPersonBuyerListingsEndpoint(),
  getHttpPostOptions(filters),
];

const getViewBuyerListingEndpoint = (productExternalReference) =>
  `${getEndpoint()}/retrieve/buyer/listing/${productExternalReference}`;
export const getViewBuyerListingRequest = (productExternalReference) => [
  getViewBuyerListingEndpoint(productExternalReference),
  getHttpGetOptions(),
];

const getUpdateBuyerListingEndpoint = () => `${getEndpoint()}/update/buyer/listing`;
export const getUpdateBuyerListingRequest = (buyerListing) => [
  getUpdateBuyerListingEndpoint(),
  getHttpPutOptions(buyerListing),
];

const getCreateSpecificationEndpoint = () => `${getEndpoint()}/create/specification`;
export const getCreateSpecificationRequest = (specification) => [
  getCreateSpecificationEndpoint(),
  getHttpPostOptions(specification),
];

const getViewAllSpecificationsEndpoint = () => `${getEndpoint()}/view/specification`;
export const getViewAllSpecificationsRequest = (filters) => [
  getViewAllSpecificationsEndpoint(),
  getHttpPostOptions(filters),
];

const getUpdateClassificationEndpoint = () => `${getEndpoint()}/update/classification`;
export const getUpdateClassificationRequest = (classification) => [
  getUpdateClassificationEndpoint(),
  getHttpPutOptions(classification),
];

const getUpdateCategoryEndpoint = () => `${getEndpoint()}/update/category`;
export const getUpdateCategoryRequest = (category) => [getUpdateCategoryEndpoint(), getHttpPutOptions(category)];

const getUpdateTypeEndpoint = () => `${getEndpoint()}/update/type`;
export const getUpdateTypeRequest = (type) => [getUpdateTypeEndpoint(), getHttpPutOptions(type)];

const getViewDashboardEndpoint = (personExternalReference) =>
  `${getEndpoint()}/view/dashboard/${personExternalReference}`;
export const getViewDashboardRequest = (personExternalReference) => [
  getViewDashboardEndpoint(personExternalReference),
  getHttpGetOptions(),
];

const getCopyListingEndpoint = () => `${getEndpoint()}/copy-listing`;
export const getCopyListingRequest = (copyListingRequest) => [
  getCopyListingEndpoint(),
  getHttpPostOptions(copyListingRequest),
];
